(function () {
    'use strict';

    angular.module('app').constant('PAGES', {
        MARKET_INFO: {
            MESSAGES: 'app/market-info/market-messages.html',
            MESSAGE: 'app/market-info/market-message.html',
            PERMISSION_DENIED: 'app/security/permission-denied.html'
        }
    });
})();
